const PPPage = () => (
    <section id="work-section" className="hero d-flex align-items-center section-bg-w">
    <div className="container">
      <div className="row justify-content-between gy-5">
        <div className="col-lg-12 tutor-box w-100 d-flex flex-column justify-content-center text-center">
          <h2 data-aos="fade-up">casovi.me – Politika zaštite ličnih podataka</h2>
<p>Ova Politika privatnosti objašnjava na koji način internet platforma casovi.me (u daljem tekstu:
"Aplikacija" ili "mi") prikuplja, koristi, obrađuje i štiti Vaše lične podatke u skladu sa Zakonom o zaštiti
podataka o ličnosti Crne Gore i drugim važećim propisima, uključujući i relevantne GDPR standarde
ukoliko su primjenjivi.</p>

<h2>1. Prikupljanje ličnih podataka tokom registracije</h2>

<h3>1.1 Registracija profesora</h3>
<p>Prilikom registracije, profesor je obavezan da unese tačne i potpune informacije, uključujući:</p>
<ul>
  <li>Ime i prezime</li>
  <li>Fotografiju</li>
  <li>Mjesto prebivališta i adresu</li>
  <li>Stepen i vrstu obrazovne kvalifikacije</li>
  <li>Kontakt telefon</li>
  <li>E-mail adresu</li>
  <li>Lozinku</li>
</ul>
<p>Svi podaci se čuvaju u sigurnoj bazi podataka, uz primjenu tehničkih i organizacionih mjera zaštite.</p>

<h3>1.2 Registracija učenika</h3>
<p>Učenik unosi sljedeće podatke prilikom registracije:</p>
<ul>
  <li>Ime i prezime</li>
  <li>Mjesto prebivališta i adresu</li>
  <li>Kontakt telefon</li>
  <li>E-mail adresu</li>
  <li>Lozinku</li>
</ul>
<p>Svi podaci su zaštićeni i koriste se isključivo u svrhu funkcionisanja Aplikacije.</p>

<h2>2. Svrha obrade ličnih podataka</h2>
<p>Podaci koje korisnici dostave koriste se isključivo u svrhu:</p>
<ul>
  <li>Registracije i pristupa platformi</li>
  <li>Uspostavljanja međusobnog kontakta i komunikacije</li>
  <li>Zakazivanja časova putem kalendara</li>
  <li>Prikaza recenzija i ocjena profesora u cilju transparentnosti i kvaliteta usluga</li>
</ul>

<h2>3. Chat komunikacija</h2>
<p>Korisnici mogu međusobno komunicirati putem integrisanog chat sistema nakon zakazivanja i
odobravanja časa. Komunikacija je enkriptovana radi zaštite podataka i sigurnosti korisnika.</p>
<p>Administrator Aplikacije ima ograničen pristup chat sadržaju samo u slučaju osnovane sumnje na
kršenje pravila, zloupotrebu ili prijavu korisnika, uz poštovanje principa zakonitosti i nužnosti.</p>

<h2>4. Pristup i prikaz podataka</h2>
<ul>
  <li>Samo osnovni podaci (ime, fotografija, kvalifikacija i opšte informacije) su javno vidljivi u okviru profila.</li>
  <li>E-mail adresa, lozinka i broj telefona nisu javno dostupni i čuvaju se uz odgovarajuće bezbjednosne mjere.</li>
  <li>Pristup kompletnim ličnim podacima ima isključivo administrativni tim casovi.me i to samo u cilju bezbjednosti i administracije sistema.</li>
</ul>

<h2>5. Čuvanje i zaštita podataka</h2>
<ul>
  <li>Lični podaci se čuvaju dok god postoji svrha njihove obrade ili dok korisnik ne zatraži brisanje.</li>
  <li>U slučaju deaktivacije naloga, svi podaci korisnika će biti trajno izbrisani, osim ako ne postoji zakonski osnov za dalje čuvanje.</li>
  <li>Svi korisnici su obavezni da svoje naloge čuvaju na bezbjedan način i ponašaju se u skladu sa uslovima korišćenja.</li>
</ul>

<h2>6. Prava korisnika</h2>
<p>Korisnici imaju sljedeća prava u skladu sa Zakonom o zaštiti podataka o ličnosti:</p>
<ul>
  <li>Pravo na informaciju</li>
  <li>Pravo na pristup</li>
  <li>Pravo na ispravku</li>
  <li>Pravo na brisanje ("pravo na zaborav")</li>
  <li>Pravo na ograničenje obrade</li>
  <li>Pravo na prigovor</li>
</ul>
<p>Za ostvarivanje svojih prava korisnici se mogu obratiti putem kontakt detalja navedenih u sekciji 9.</p>

<h2>7. Kolačići (Cookies)</h2>
<p>Naša Aplikacija koristi kolačiće i slične tehnologije radi poboljšanja korisničkog iskustva.</p>
<ul>
  <li>Tehničke/funkcionalne</li>
  <li>Statističke (anonimizovane)</li>
  <li>Marketing kolačiće (uz pristanak korisnika)</li>
</ul>
<p>Prilikom prve posjete, tražimo pristanak korisnika na korišćenje kolačića kroz iskačuće obavještenje.</p>

<h2>8. Upravljanje kolačićima</h2>
<p>Korisnici mogu u bilo kom trenutku onemogućiti ili obrisati kolačiće kroz podešavanja svog
pretraživača. Ukoliko se svi kolačići onemoguće, moguće je da Aplikacija neće raditi optimalno.</p>

<h2>9. Kontakt podaci</h2>
<p>Za sva pitanja, zahtjeve i komentare u vezi sa ovom Politikom privatnosti, možete nas kontaktirati putem:</p>
<ul>
  <li>Email: [unesite email]</li>
  <li>Telefon: [unesite broj telefona]</li>
  <li>Adresa: [unesite adresu sjedišta]</li>
  <li>Web: www.casovi.me</li>
</ul>

<h2>10. Pravni osnov obrade podataka</h2>
<p>Obrada ličnih podataka korisnika vrši se na osnovu:</p>
<ul>
  <li>Pristanka korisnika</li>
  <li>Izvršenja ugovora</li>
  <li>Zakonske obaveze</li>
  <li>Legitimnog interesa</li>
</ul>
<p>Korisnik ima pravo da u bilo kom trenutku povuče dati pristanak, pri čemu to ne utiče na zakonitost obrade prije povlačenja.</p>

<h2>11. Prijenos podataka trećim licima</h2>
<ul>
  <li>Imamo vaš izričit pristanak</li>
  <li>Postoji zakonska obaveza ili nalog nadležnog organa</li>
  <li>Treće lice djeluje kao izvršilac obrade (npr. pružalac hosting usluge) uz adekvatnu zaštitu</li>
</ul>

<h2>12. Prenos podataka van Crne Gore / EU</h2>
<p>Podaci korisnika se, u pravilu, čuvaju i obrađuju unutar teritorije Crne Gore ili zemalja koje obezbjeđuju adekvatan nivo zaštite podataka.  
Ukoliko dođe do prenosa podataka van ovih teritorija, biće preduzete sve zakonom propisane mjere zaštite.</p>

<h2>13. Sigurnosne mjere</h2>
<ul>
  <li>Enkripcija osjetljivih podataka</li>
  <li>Kontrola pristupa i autentifikacija</li>
  <li>Interna pravila pristupa podacima</li>
  <li>Periodične bezbjednosne provjere</li>
</ul>

<h2>14. Nadležni organ i pravna zaštita</h2>
<p>Ukoliko smatrate da je došlo do povrede vaših prava u vezi sa obradom ličnih podataka, imate pravo
da podnesete pritužbu Agenciji za zaštitu ličnih podataka i slobodan pristup informacijama Crne Gore:</p>
<ul>
  <li>Adresa: Bulevar Svetog Petra Cetinjskog 147, Podgorica</li>
  <li>Web: www.azlp.me</li>
  <li>Email: azlp@t-com.me</li>
</ul>
<p>Takođe, imate pravo na sudsku zaštitu u skladu sa važećim zakonodavstvom.</p>
        </div>
      </div>
    </div>
  </section>
);

export default PPPage;